module.exports = __webpack_public_path__ + "static/media/pyramid_bonanza.pragmaticplay.3a598a07.jpeg";